// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__QjIcm","productName":"Table_productName__3GXCQ"};